import React from 'react';
import DeliveryZonesMap from '../../DeliveryZonesMap';

export default function DeliveryTab({ restaurant, setSuccess }) {
  return (
        <div className="glass-card">
          <h2 className="text-xl sm:text-2xl font-semibold text-white mb-6 sm:mb-8">Configurar Zonas de Entrega</h2>
          <p className="text-gray-400 mb-6">
            Configure a localização do seu estabelecimento e defina os raios de entrega com taxas e tempos estimados.
          </p>
          <DeliveryZonesMap 
            restaurantId={restaurant?.id}
            initialLocation={restaurant?.latitude && restaurant?.longitude ? {
              lat: restaurant.latitude,
              lng: restaurant.longitude
            } : null}
            onLocationChange={(loc) => {
              console.log('Nova localização:', loc);
            }}
            onSave={(config) => {
              setSuccess('Configurações de entrega salvas com sucesso!');
            }}
          />
        </div>
  );
}
